import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";
import type { ListCompanyConfigsParams } from "../../generated/core-api";

/**
 * List company configurations (latest published version per config).
 * Wraps `api.listCompanyConfigs`; see `src/org/hooks` for the query-hook pattern.
 */
export function useCompanyConfigs(params?: ListCompanyConfigsParams) {
  return useQuery({
    queryKey: ["companyConfigs", params ?? null],
    queryFn: () => api.listCompanyConfigs(params),
  });
}
